import React from 'react';
import { CarteModificationBase } from './CarteModificationBase';
import { t } from '../i18n';
import type { CvChange } from '../types';

export interface CarteModificationProps {
  change: CvChange;
  // Où se trouve la modification (« Stagiaire · ACME »), null pour le titre du CV.
  lieu: string | null;
  retenue: boolean;
  onToggle: (retenue: boolean) => void;
  // Figé pendant l'enregistrement : on ne change plus ce qui est en train d'être appliqué.
  disabled?: boolean;
  testID?: string;
}

/**
 * Une modification du CV : ses libellés (nature, emplacement, nom de l'interrupteur) sur la carte
 * commune. Le titre du CV a son libellé ; une puce dont on ne sait pas dire où elle est n'en prend aucun.
 */
export function CarteModification({ change, lieu, retenue, onToggle, disabled = false, testID = 'modif' }: CarteModificationProps) {
  const tag = t(`cvImprove.tags.${change.tag}`);
  const emplacement = change.target === 'headline' ? t('cvImprove.modif.titreCv') : lieu;
  // Début du nouveau texte : deux puces du même poste et de la même nature se distinguent au lecteur d'écran.
  const extrait = change.after.length > 40 ? `${change.after.slice(0, 40).trimEnd()}…` : change.after;
  const nom = [tag, emplacement, extrait].filter(Boolean).join(', ');
  return (
    <CarteModificationBase
      testID={testID}
      tag={tag}
      lieu={emplacement}
      // Rôle, entreprise ou nom de projet : du texte de CV, donc de gauche à droite.
      lieuDuDocument={change.target === 'bullet'}
      reason={change.reason}
      before={change.before}
      after={change.after}
      nomInterrupteur={t('cvImprove.modif.appliquer', { nom })}
      retenue={retenue}
      onToggle={onToggle}
      disabled={disabled}
    />
  );
}
